module.exports = __webpack_public_path__ + "img/Martenitsa-blossom.3a40b885.jpg";